import { BaseNavLink } from '@enter/core';
import { mdiChevronRight } from '@mdi/js';
import React from 'react';
import { NavLinkProps } from 'react-router-dom';
import * as S from './sub-category-link.styles';

export interface ISubCategoryLinkProps extends NavLinkProps {
    first?: boolean;
    label: string;
    value?: string;
}

export class SubCategoryLink extends React.PureComponent<ISubCategoryLinkProps> {
    public render(): React.ReactElement {
        const { first, label, value, ...navLinkProps } = this.props;
        return (
            <BaseNavLink exact={true} {...navLinkProps}>
                {(props): React.ReactElement => (
                    <S.SubCategoryLink active={props.active} first={first}>
                        {label && value && (
                            <S.Pair>
                                <S.Label>{label}</S.Label>
                                <S.Value>{value}</S.Value>
                            </S.Pair>
                        )}
                        {label && !value && <S.Label>{label}</S.Label>}

                        <S.Chevron path={mdiChevronRight} size={1} />
                    </S.SubCategoryLink>
                )}
            </BaseNavLink>
        );
    }
}
